import TimeHelper from "../../../services/TimeHelper";
import i18n from "../../../i18n";

function formatTime(date) {
  if (i18n.language === 'fr') {
    const h = date.getHours();
    const m = date.getMinutes().toString().padStart(2, '0');
    return `${h} h ${m}`;
  }
  return date.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
}

export class BookingEvent {
  associated_employees
  available_online;
  duration;
  eligible_to_book;
  eligible_to_buy;
  event_level_id;
  event_level_name;
  event_namel;
  event_type_id;
  free_of_charge;
  has_prior_unfunded_events;
  session_credits_left;

  constructor(data) {
  	Object.assign(this, data);
  }

  shouldBuy () {
    return !this.eligible_to_book && this.eligible_to_buy;
  }
}

export class EventAvailability {
  club_number;
  employee_id;
  end_date_time;
  start_date_time;

  constructor(data) {
    Object.assign(this, data);
    this.start_date_time = new Date(this.start_date_time.substring(0, 19));
    this.end_date_time = new Date(this.end_date_time.substring(0, 19));
  }

  getStartTime() {
    return formatTime(this.start_date_time);
  }

  getSlotStart() {
    return TimeHelper.toApiDate(this.start_date_time);
  }


}

export class Booking { // should share Slot interface with Availability
  constructor(data) {
    Object.assign(this, data);
    this.start_date_time = this.booked_at = new Date(this.booked_at.substring(0, 19));
  }

  getStartTime() {
    return formatTime(this.start_date_time);
  }

  getSlotStart() {
    return TimeHelper.toApiDate(this.start_date_time);
  }
}